<template>
  <div class="placeholder"></div>
  <div id="call_statistics"></div>
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  onBeforeMount,
  watch,
  onUnmounted,
} from 'vue'
import * as echarts from 'echarts'
import { callStatistics } from '@/api/performance'
import { useRouter } from 'vue-router'
export default defineComponent({
  props: ['date', 'userId'],
  setup(props, context) {
    let router = useRouter()
    let myEcharts = ref(null)
    const option = {
      legend: {
        show: true,
        right: 0,
      },
      tooltip: {
        show: true,
        trigger: 'axis',
        // formatter: (value) => {
        //   return `
        //   ${value[0].data[0]}<br/>
        //   Missed: ${value[0].data[2]}<br/>
        //   picked up: ${value[0].data[3]}<br/>
        //   total call time: ${value[0].data[1]}min
        //   `
        // },
      },
      xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
          rotate: 25,
        },
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: 'Answered calls',
          data: [],
          type: 'bar',
        },
        {
          name: 'Missed',
          data: [],
          type: 'bar',
        },
      ],
    }
    function getCallStatistics() {
      const submitForm = props.date
      if (router.currentRoute.value.query.userId) {
        submitForm.userId = router.currentRoute.value.query.userId
      } else {
        submitForm.userId = props.userId || 0
      }
      callStatistics(submitForm).then((res) => {
        option.xAxis.data = []
        option.series[0].data = []
        option.series[1].data = []
        res.data.forEach((el) => {
          option.xAxis.data.push(el.date)
          option.series[0].data.push(el.successTalkCount)
          option.series[1].data.push(el.missTalkCount)
        })
        if (myEcharts) {
          myEcharts.dispose()
        }
        myEcharts = echarts.init(document.getElementById('call_statistics'))
        myEcharts.setOption(option)
      })
    }
    // onBeforeMount(() => {
    //   getCallStatistics()
    // })
    onMounted(() => {
      myEcharts = echarts.init(document.getElementById('call_statistics'))
      option && myEcharts.setOption(option)
      window.addEventListener('resize', function () {
        myEcharts.resize()
      })
    })
    onUnmounted(() => {
      window.removeEventListener('resize', function () {
        myEcharts.resize()
      })
    })
    watch(
      () => props.userId,
      (newValue, oldValue) => {
        getCallStatistics()
      },
      { deep: true, immediate: false }
    )
    watch(
      () => props.date.endTime,
      (newValue, oldValue) => {
        getCallStatistics()
      },
      {
        deep: true,
        immediate: true,
      }
    )
    return {
      getCallStatistics,
      option,
    }
  },
})
</script>

<style lang="less" scoped>
#call_statistics {
  min-height: 400px;
}
.placeholder {
  height: 42px;
}
</style>
